
    import Vue from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import XModalCancel from '@/apps/shared/components/modalCancel.vue';
    import { SummaryDetails } from '@/apps/shared/models/summaryDetails';
    import { safeRedirect } from '@/apps/shared/utils/safeRedirectHelper';

    export default Vue.extend({
        name: 'ElectronicDeviceSummary',
        props: {
            productDetails: {
                type: Object as () => SummaryDetails,
                required: true,
            }
        },
        components: {
            XBreadcrumb,
            XModalCancel
        },
        data() {
            return {
                pageBlocked: false
            }
        },
        methods: {
            async redirectToCupe() {
                NF.UI.Page.block();
                if (this.productDetails.cupeUrl) {
                    sessionStorage.setItem("ExitOrContinueModal", "false");
                    await safeRedirect(this.productDetails.cupeUrl, null, this.$router);
                } else {
                    console.error('URL no válida');
                }
                NF.UI.Page.unblock();
            }            
        },
        mounted() {
            NF.UI.Page.block({
                 message: [
                    {
                        text: "Cargando datos.."
                    },
                ],
                element: "#block-page-panel",
            });
            sessionStorage.setItem("ExitOrContinueModal", "true");
        },
        watch: {
            'productDetails.cupeUrl'(newValue) {
                if (newValue) {                    
                    this.$nextTick(() => {
                        NF.UI.Element.unblock('#block-page-panel');
                    });
                }
            }
        },
    });
